import { Box, Text } from '@factorialco/deprecated-design-system'
import SoftwareManagementMonitorFlashIcon from 'assets/images/it-management-monitor-flash.svg'

import i18n from 'modules/core/lib/i18n'

const DataUnavailable = () => {
  return (
    <Box alignItems="center" gap="s16" justifyContent="center">
      <img width="s24" height="s24" src={SoftwareManagementMonitorFlashIcon} />
      <Box alignItems="center" gap="s4" justifyContent="center" textAlign="center">
        <Text.Header2>
          {i18n.t('software_management.software_setups.costs.no_data.title')}
        </Text.Header2>
        <Text.Normal>
          {i18n.t('software_management.software_setups.costs.no_data.description')}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default DataUnavailable
